import { createApiDescription } from "../../helperFunctions";

export const signatureStatusInfo = {
    signatureStatus: createApiDescription(
        "This API is used to change the status to downloaded for the given signature document.",
        [
            "Status of the document will be changed to downloaded only for applicable statuses.",
            "This API changes the status to downloaded in the grid, download documents popup and update required entries in client tracking as well.",
            "Signature status API can be used to update the status to download for single as well as multiple files associated with the respective signature document."
        ]
    )
}